import React from 'react';
import { useLeadModal } from '../context/LeadModalContext';

export default function EmailCaptureSection() {
  const { openModal } = useLeadModal();

  return (
    <section className="section email-capture-section" id="join" aria-label="Join waitlist">
      <div className="email-capture-bg" aria-hidden />
      <div className="email-capture-shell">
        <div className="email-capture-card">
          <div className="email-capture-copy">
            <p className="email-capture-eyebrow">
              <span className="email-capture-eyebrow-dot" aria-hidden />
              Early access
            </p>
            <h2 className="email-capture-title">Get Notrack early access</h2>
            <p className="email-capture-sub">
              Join the waitlist for a <strong>no tracking diet</strong> built for India—founding pricing for early users.
            </p>
            <ul className="email-capture-badges" aria-label="What you get">
              <li>No spam</li>
              <li>Cancel anytime</li>
              <li>Founding pricing</li>
            </ul>
          </div>

          <div className="email-capture-actions" aria-label="Join early access">
            <button type="button" className="btn btn-primary email-capture-btn" onClick={() => openModal('Founding Plan')}>
              👉 Lock Early Access
            </button>
            <p className="email-capture-fineprint">
              No credit card required. You’ll fill your details in the next step.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
